import React from "react";
import CustomModal from "widgets/Modal/CustomModal";
import CustomTable from "widgets/Table/CustomTable";
import PrimaryButton from "widgets/Buttons/PrimaryButton";
import VerticalRegistry from "constants/verticalRegistry";
import styles from "./StudentDetails.module.scss";

const StudentProfileSelectionModal = ({
  open,
  onClose,
  profiles,
  onSelectProfile,
}) => {
  const profileColumns = [
    {
      id: "name",
      label: "Name",
      render: (row) =>
        `${row.account.firstName || ""} ${row.account.lastName || ""}`.trim() ||
        "N/A",
    },
    {
      id: "vertical",
      label: "Business Vertical",
      render: (row) => {
        const vId =
          row.profile.verticalId !== undefined
            ? row.profile.verticalId
            : row.profile.vertical_id;
        return VerticalRegistry.getVertical(vId)?.name || vId || "N/A";
      },
    },
    {
      id: "uamId",
      label: "UAM ID",
      render: (row) => row.profile.uamId || row.profile.uam_id || "N/A",
    },
    {
      id: "action",
      label: "Action",
      render: (row) => (
        <PrimaryButton
          onClick={() => onSelectProfile(row)}
          className={styles.profileSelectButton}
        >
          Select
        </PrimaryButton>
      ),
    },
  ];

  return (
    <CustomModal
      open={open}
      onClose={onClose}
      title="Multiple Profiles Found"
      maxWidth="md"
      fullWidth={false}
    >
      <div className={styles.modalSubtitle}>
        Multiple profiles exist for the provided details within this vertical.
        Please select the required profile to continue.
      </div>
      <CustomTable
        columns={profileColumns}
        data={profiles}
        noDataMessage="No profiles found."
        className={styles.plainTable}
      />
    </CustomModal>
  );
};

export default StudentProfileSelectionModal;
